import i18n from "i18next";
import translation from "./translations/en.json";

export const resources = {
  en: {
    "nuco-auth": translation,
  },
} as const;

const nucoAuthI18n = i18n.createInstance();

nucoAuthI18n.init({
  resources,
  lng: "en",
  ns: ["nuco-auth"],
  defaultNS: "nuco-auth",
  keySeparator: ".",
  interpolation: {
    escapeValue: false,
  },
});

export default nucoAuthI18n;
